import { broadcastMessage, BroadcastMessageType } from '../lib/broadcastMessage'

import { openLinkInExternalWindow } from '../lib/openLinkInExternalWindow'

const {
  VITE_GOOGLE_CHROME_EXTENSION_ID: GOOGLE_CHROME_EXTENSION_ID,
  VITE_MICROSOFT_EDGE_EXTENSION_ID: MICROSOFT_EDGE_EXTENSION_ID,
} = import.meta.env

function heightOfPage() {
  const overflowElement = document.querySelector('.pds-chosen-dropdown')
  const bodyHeight = document.body.offsetHeight

  if (overflowElement) {
    const overflowElementHeight = overflowElement.getBoundingClientRect().bottom

    if (bodyHeight < overflowElementHeight) {
      // 20 is a 'visually_pleasing_amount_of_padding'
      return overflowElementHeight + 20
    } else {
      return bodyHeight
    }
  }

  return bodyHeight
}

let storedHeight

export function watchForHeightChanges() {
  const value = heightOfPage()
  if (value !== storedHeight) {
    broadcastMessage({
      type: BroadcastMessageType.FrameResize,
      value: value,
      crossOrigin: true,
    })

    storedHeight = value
  }
}

export function extractTimeEntryQueryParams(searchParams) {
  const properties = [
    'permalink',
    'external_account_id',
    'external_group_id',
    'external_group_name',
    'external_item_id',
    'external_item_name',
    'service',
    'app_name',
    'version',
  ]

  const params = {}
  properties.forEach((property) => {
    const value = searchParams.get(property)
    if (value) {
      params[property] = value
    }
  })
  if (searchParams.has('base_url') && !params['permalink']) {
    const value = searchParams.get('base_url')
    if (value) params.permalink = value
  }
  if (!params.service) {
    try {
      const url = new URL(document.referrer)
      params.service = url.hostname
    } catch {} // eslint-disable-line no-empty
  }
  return params
}

export const localStorageEnabled = (() => {
  const key = 'platform'
  try {
    localStorage.setItem(key, key)
    localStorage.removeItem(key)
    return true
  } catch (e) {
    return false
  }
})()

export function postCredentialsToChromeExtension(accessToken, accountId) {
  let extensionOrigin = `chrome-extension://${GOOGLE_CHROME_EXTENSION_ID}`

  if (navigator.userAgent.includes('Edg/')) {
    extensionOrigin = `chrome-extension://${MICROSOFT_EDGE_EXTENSION_ID}`
  }

  try {
    if (window.parent.origin !== extensionOrigin) {
      // Parent origin does not match extension, so no need to attempt
      // to `postMessage` which will throw a cross-origin error anyway
      return
    }
  } catch (e) {
    // Could not read parent origin information, likely due to a cross-origin
    // iframe. Need to rely on `postMessage`’s `targetOrigin` filter below
  }

  try {
    broadcastMessage({
      crossOrigin: true,
      targetOrigin: extensionOrigin,
      type: BroadcastMessageType.AuthCredentials,
      value: { accessToken, accountId },
    })
  } catch (e) {
    if (e.name === 'SyntaxError') {
      // Posting a message to a Chrome extension origin in Safari
      // throws a SyntaxError: The string did not match the expected pattern.
      return
    } else {
      throw e
    }
  }
}

export function switchOrSelectAccount(url) {
  openLinkInExternalWindow(url)
}

const WEEK_START_DAYS = {
  Sunday: 0,
  Monday: 1,
  Tuesday: 2,
  Wednesday: 3,
  Thursday: 4,
  Friday: 5,
  Saturday: 6,
}

export function getWeekStartIndex(day = 'Sunday') {
  return WEEK_START_DAYS[day]
}
